var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "rules"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/rules-bg.jpg")
    }
  }), _c('div', {
    staticClass: "rules__info"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'LiffProjAbbottAnd2026LotteryEarnCount',
        query: _vm.$route.query
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/rules-btn.png")
    }
  })])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }